import XSelect from "../common/XSelect";
import DemandStudioPreviewClientSelect from "./DemandStudioPreviewClientSelect";
import useDemandStudioPreviewSelectors from "../../hooks/useDemandStudioPreviewSelectors";

const containerClasses = "inline-flex items-center gap-2";

const selectClasses = "h-10 py-1 px-2 text-sm min-w-[10rem] max-w-[16rem]";

const renderXSelect = (selector) => (
  <XSelect
    id={selector.id}
    aria-label={selector.ariaLabel}
    className={selectClasses}
    value={selector.value}
    onChange={selector.onChange}
    options={selector.options}
    emptyOption={false}
  />
);

const DemandStudioPreviewSelectors = ({ previewState }) => {
  const { shouldRender, demandSelector, clientSelector, docxSelector } =
    useDemandStudioPreviewSelectors({ previewState });

  if (!shouldRender) return null;

  return (
    <div className={containerClasses}>
      {demandSelector && renderXSelect(demandSelector)}
      {clientSelector && <DemandStudioPreviewClientSelect {...clientSelector} />}
      {docxSelector && renderXSelect(docxSelector)}
    </div>
  );
};

export default DemandStudioPreviewSelectors;
